var map = {
	"./memoseq.png": 599,
	"./memoseq_responsive.png": 600,
	"./mirror.png": 601,
	"./mirror_responsive.png": 602,
	"./objectsRain.png": 603,
	"./objectsRain_responsive.png": 604,
	"./recycling.png": 605,
	"./recycling_responsive.png": 606,
	"./sequences.png": 607,
	"./sequences_responsive.png": 608,
	"./whac_a_mole.png": 609,
	"./whac_a_mole_responsive.png": 610,
	"./words.png": 611,
	"./words_responsive.png": 612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;